import type { ComponentType } from 'react';
import type { ContactInfo } from './steps/contactSchema';

export type WizardStepId = 'unexpected' | 'made' | 'proud' | 'about' | 'submission' | 'end';
export type QuestionStepId = 'unexpected' | 'made' | 'proud' | 'about';
export type AllAnswerKey = QuestionStepId | keyof ContactInfo;

export interface WizardStepProps {
    value: string;
    onChange: (value: string) => void;
}

interface QuestionStepFormProps {
    contact: ContactInfo;
    onChange: (contact: ContactInfo) => void;
}

export enum WizardStepKind {
    Question = 'question',
    Form = 'form',
    End = 'end',
}

export type WizardStepDef =
    | { id: QuestionStepId; kind: WizardStepKind.Question; Component: ComponentType<WizardStepProps> }
    | { id: 'submission'; kind: WizardStepKind.Form; Component: ComponentType<QuestionStepFormProps> }
    | { id: 'end'; kind: WizardStepKind.End; Component: ComponentType<Record<string, never>> };
